export default __webpack_public_path__ + "static/media/sampleHandlebars.6cda5aca.svg";